import { FC } from 'react';

interface HouseholdInfoBoxContentProps {
  propertyName?: string | null;
  canManage: boolean;
}

const HouseholdInfoBoxContent: FC<HouseholdInfoBoxContentProps> = ({
  propertyName,
  canManage,
}) => {
  if (!canManage) {
    return (
      <p>
        Update your details or complete any required actions for your
        application.
      </p>
    );
  }

  return (
    <>
      <p>
        Please review your household
        {propertyName && (
          <>
            {' for '}
            <b>{propertyName}</b>
          </>
        )}
        . Include every household member who lives or will live with you and
        ensure accurate information.
      </p>
      <p>Add new household members if needed.</p>
    </>
  );
};

export default HouseholdInfoBoxContent;
